import UpdatedAtCell from 'components/cell/UpdatedAtCell';

import LeadName from './LeadName';

export const TABLE_COLUMNS = [
  {
    Header: 'Flow',
    accessor: 'source',
    subAccessors: [],
    items: [],
    width: 120,
    minWidth: 100,
    maxWidth: 120,
  },
  {
    Header: 'Name',
    accessor: 'lead_applicant.customer_details',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
    renderComponent: {
      component: LeadName,
      value: 'customerDetails',
      optionalProps: ['lastName'],
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'Email',
    accessor: 'lead_applicant.customer_details.email',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'Last Activity',
    accessor: 'metadata.updated_at',
    items: [
      {
        action: {
          type: 'activity-ascending',
        },
        icon: 'sort-ascending',
        name: 'Sort ascending',
      },
      {
        action: {
          type: 'activity-descending',
        },
        icon: 'sort-descending',
        name: 'Sort descending',
      },
    ],
    width: 140,
    renderComponent: {
      component: UpdatedAtCell,
      value: 'date',
    },
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const SORTING = {
  UPDATED_AT: 'UPDATED_AT',
  NAME: 'NAME',
  ID: 'ID',
  COMPANY: 'COMPANY',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const FILTER_TYPES = {
  NONE: 'NONE',
  STATUS: 'STATUS',
};

export const SEARCH_OPTIONS = {
  keys: [
    { name: 'id', weight: 1 },
    { name: 'source', weight: 1 },
    { name: 'status', weight: 1 },
    { name: 'lead_applicant.customer_details.first_name', weight: 1 },
    { name: 'lead_applicant.customer_details.last_name', weight: 1 },
    { name: 'lead_applicant.customer_details.email', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};
